<template>
  <div class="application-stage">
    <div class="application-stage__header">
      <el-form
        ref="form-body"
        :model="form"
        :rules="rules"
        label-width="100%"
        :size="formSize"
        enctype="multipart/form-data"
        class="header-form"
      >
        <div class="no-margin">
          <form-field
            :key="`${formFields.name.name}`"
            :item="{
              ...formFields.name,
              lbl: 'Название',
              placeholder: 'Этап'
            }"
            :form="form"
            :form-size="formSize"
            :options="options"
            :blocked="blocked"
            class="header-form__field-name"
            @set-value="setFieldValue"
          ></form-field>
          <form-field
            :key="`${formFields.coordination_term_int.name}_${updateKey}`"
            :item="{
              ...formFields.coordination_term_int,
              lbl: 'Срок в раб. дн.',
              validation: {
                max: 999
              }
            }"
            :form="form"
            :form-size="formSize"
            :options="options"
            :blocked="blocked"
            :class="[
              'header-form__field-coordination-term',
              { 'no-error': noError }
            ]"
            @set-value="validateAndSetCoordTermValue"
          ></form-field>
          <form-field
            :key="`${formFields.operator.name}`"
            :item="{
              ...formFields.operator,
              lbl: 'Порядок согласования',
              required: true,
              clearable: false
            }"
            :form="form"
            :form-size="formSize"
            :options="options"
            :blocked="blocked"
            :defaultFirstOption="true"
            class="header-form__field-operator"
            @set-value="setFieldValue"
          ></form-field>
          <Button
            v-if="showDeleteStageButton"
            buttonSize="big"
            buttonColor="transparent"
            hasLeftIcon
            iconName="delete-trash"
            buttonText="Удалить этап"
            class="header__delete-stage-button"
            @click="deleteStage"
          />
        </div>
      </el-form>
    </div>
    <div class="application-stage__body">
      <div class="application-stage-coordinators">
        <div
          class="coordinator"
          v-for="(coordinator, i) in coordinators"
          v-show="!coordinator.deleted"
          :key="`coord-${i}`"
        >
          <Dropdown
            :key="`${fields.hrpac_coordination_stage_result.value[0].coordinator_type.name}${i}`"
            :field="coordinator.coordinator_type"
            :model="form.hrpac_coordination_stage_result[i].coordinator_type"
            :options="coordinator.coordinator_type.options"
            defaultFirstOption
            :clearable="false"
            class="coordinator__type"
            :callback="val => changeFieldValue('coordinator_type', val, i)"
          />
          <Dropdown
            ref="coordinator-value-dropdown"
            v-loading="coordinator.coord_value_loading"
            :key="`${fields.hrpac_coordination_stage_result.value[0].user_name.name}${i}`"
            :field="{
              ...coordinator.user_name,
              placeholder: 'Выберите',
              required: true
            }"
            :clearable="false"
            filterable
            :model="form.hrpac_coordination_stage_result[i].user_name"
            :options="coordinatorsNames(coordinator.user_name.options)"
            class="coordinator__value"
            :callback="val => changeFieldValue('user_name', val, i)"
          />
          <Button
            v-if="i !== 0 ? showDeleteCoordinatorButton : false"
            buttonSize="big"
            buttonColor="transparent"
            hasLeftIcon
            iconName="DelUser"
            buttonText="Удалить согласующего"
            class="coordinator__delete-button"
            @click="deleteCoordinator(coordinator)"
          />
        </div>
        <Button
          buttonSize="big"
          buttonColor="blue"
          hasLeftIcon
          iconName="AddUser"
          buttonText="Добавить согласующего"
          class="coordinator__add-button"
          @click="addCoordinator"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getController } from '@/controllers/request';
import { DEFAULT_FORM_SIZE, MODULE } from '@/utils/constants';
import { form, metadata, mixin, rules, saveForm } from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import FormField from 'Elements/Form/FormField';
import Dropdown from 'Elements/Select/Dropdown';
import { Form } from 'element-ui';
export default {
  mixins: [mixin, form, metadata, saveForm, rules],
  components: {
    'el-form': Form,
    FormField,
    Button,
    Dropdown
  },
  props: {
    fields: Object,
    showDeleteStageButton: {
      type: Boolean,
      default: false
    },
    setCoordinationTerm: {
      type: Boolean,
      default: true
    },
    getFieldVals: Function,
    options: Object,
    getObjectWithoutValue: Function,
    hrpac_coordination_id: {
      type: String,
      default: ''
    },
    deleted: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.coordinators = [...this.fields.hrpac_coordination_stage_result.value];
    this.form = this.getFieldVals(this.fields);
    this.formFields = this.fields;
    this.changeCTVisibility();
    if (this.formFields.name.required) {
      this.formFields.name.required = !this.formFields.name.required;
    }
    if (!this.coordinators.length) this.addCoordinator();
    if (this.coordinators.length == 1 && !this.coordinators[0].id.value) {
      const id = this.generateCoordinatorId();
      this.$set(this.coordinators[0], 'coord_id', {
        value: id
      });
      this.$set(this.form.hrpac_coordination_stage_result[0], 'coord_id', id);
    }
    this.form.deleted = this.fields.deleted;
  },
  data() {
    return {
      coordinators: {},
      formSize: DEFAULT_FORM_SIZE,
      formFields: {},
      form: {},
      updateKey: 0,
      blocked: {}
    };
  },
  watch: {
    setCoordinationTerm() {
      this.changeCTVisibility();
      this.changeCTVValue();
    },
    deleted() {
      this.form.deleted = this.deleted ? 1 : 0;
      if (this.deleted) {
        this.form.hrpac_coordination_stage_result =
          this.form.hrpac_coordination_stage_result.filter(val => val.id);
        this.form.hrpac_coordination_stage_result.forEach(
          val => (val.deleted = 1)
        );
      }
    }
  },
  computed: {
    showDeleteCoordinatorButton() {
      return this.coordinators.filter(val => val.id && !val.deleted).length > 1;
    },
    rules() {
      return this.setCoordinationTerm
        ? {
            operator: {
              required: true,
              message: 'Необходимо заполнить поле',
              trigger: ['blur', 'focus', 'change']
            },
            coordination_term_int: {
              required: true,
              message: 'Необходимо заполнить поле',
              trigger: ['blur', 'focus', 'change']
            }
          }
        : {
            operator: {
              required: true,
              message: 'Необходимо заполнить поле',
              trigger: ['blur', 'focus', 'change']
            }
          };
    },
    noError() {
      return this.form.coordination_term_int;
    }
  },
  methods: {
    validateAndSetCoordTermValue(name, value, blocked) {
      if (Number(value) <= 999) {
        this.setFieldValue(name, value, blocked);
      } else {
        this.setFieldValue(name, '999', blocked);
        this.updateKey++;
      }
    },
    coordinatorsNames(option) {
      var sortable = [];
      for (var opt in option) {
        sortable.push([opt, option[opt]]);
      }

      sortable.sort(function (a, b) {
        return a[1].localeCompare(b[1]);
      });

      const objSorted = {};
      sortable.forEach(function (item) {
        objSorted[item[0]] = item[1];
      });
      return objSorted;
    },
    generateCoordinatorId() {
      let num = 0;
      let coordinatorId = '';
      let finish = false;
      do {
        coordinatorId = `newCoordinator${num}`;
        this.coordinators.length > 0
          ? this.coordinators.find(el => {
              return el.coord_id
                ? el.coord_id.value.includes(coordinatorId)
                : false;
            })
            ? num++
            : (finish = true)
          : (finish = true);
      } while (!finish);
      return coordinatorId;
    },
    deleteStage() {
      this.$emit(
        'delete-stage',
        this.fields.id.value ? this.fields.id.value : this.fields.stage_id.value
      );
    },
    addCoordinator() {
      if (!this.form.hrpac_coordination_stage_result)
        this.form.hrpac_coordination_stage_result = [];
      this.form.hrpac_coordination_stage_result.push({
        id: '',
        coord_id: this.generateCoordinatorId(),
        status: '',
        description: '',
        coordinator_type: '',
        user_id: '',
        user_value: '',
        user_name: ''
      });
      this.coordinators = [
        ...this.coordinators,
        {
          id: {
            name: 'id',
            type: 'id',
            value: ''
          },
          coord_value_loading: false,
          coord_id: {
            value: this.generateCoordinatorId()
          },
          user_name: this.getObjectWithoutValue(
            this.fields.hrpac_coordination_stage_result.value[0].user_name
          ),
          coordinator_type: this.getObjectWithoutValue(
            this.fields.hrpac_coordination_stage_result.value[0]
              .coordinator_type
          )
        }
      ];
    },
    deleteCoordinator(coordinator) {
      const coordToDel = coordinator.id.value
        ? this.form.hrpac_coordination_stage_result.find(
            coord => coord.id == coordinator.id.value
          )
        : this.form.hrpac_coordination_stage_result.find(
            coord => coord.coord_id == coordinator.coord_id.value
          );
      const coordToDelIndex =
        this.form.hrpac_coordination_stage_result.indexOf(coordToDel);
      if (coordinator.id.value) {
        this.$set(
          this.form.hrpac_coordination_stage_result[coordToDelIndex],
          'deleted',
          1
        );
        this.$set(this.coordinators[coordToDelIndex], 'deleted', 1);
      } else {
        this.form.hrpac_coordination_stage_result.splice(coordToDelIndex, 1);
        this.coordinators.splice(coordToDelIndex, 1);
      }
    },
    async changeFieldValue(field, val, i) {
      this.form.hrpac_coordination_stage_result[i][field] = val;
      if (field == 'coordinator_type') {
        try {
          this.coordinators[i].coord_value_loading = true;
          this.loadCoordinators = true;
          const data = await getController({
            params: {
              module: MODULE.HRPAC_COORDINATION_PLANS,
              action: 'getList',
              type: val,
              hrpac_coordination_id: this.hrpac_coordination_id,
              to_pdf: true
            }
          });
          this.$set(this.coordinators[i].user_name, 'options', data.data);
          this.form.hrpac_coordination_stage_result[i]['user_name'] = '';
        } catch (err) {
          console.log(err);
          this.coordinators[i].coord_value_loading = false;
        } finally {
          this.coordinators[i].coord_value_loading = false;
        }
      } else {
        this.$refs['coordinator-value-dropdown'][i].$el.classList.remove(
          'empty-value'
        );
      }
    },
    validateAndGetStageInfo() {
      let formValid = '';
      let formToSend = { ...this.form };
      if (formToSend.name == '') {
        formToSend.name = 'Этап';
      }
      //удаление технических полей id
      delete formToSend.stage_id;
      formToSend.hrpac_coordination_stage_result.forEach(
        coordinator => delete coordinator.coord_id
      );
      let hasEmptyCoodinator = false;
      for (
        let i = 0;
        i < this.form.hrpac_coordination_stage_result.length;
        i++
      ) {
        if (!this.form.hrpac_coordination_stage_result[i].user_name) {
          this.$refs['coordinator-value-dropdown'][i].$el.classList.add(
            'empty-value'
          );
          if (
            this.form.deleted != 1 &&
            this.form.hrpac_coordination_stage_result[i].deleted != 1
          )
            hasEmptyCoodinator = true;
        }
      }
      this.$refs['form-body'].validate(valid => {
        (valid && !hasEmptyCoodinator) || this.form.deleted
          ? (formValid = { validationResult: 'valid', formInfo: formToSend })
          : (formValid = { validationResult: 'not valid' });
      });
      return formValid;
    },
    changeCTVValue() {
      this.$set(
        this.formFields.coordination_term_int,
        'required',
        this.setCoordinationTerm
      );
      if (!this.setCoordinationTerm) {
        this.form.coordination_term_int = '';
        this.$set(this.formFields.coordination_term_int, 'value', '');
      }
      this.updateKey++;
    },
    changeCTVisibility() {
      this.$set(
        this.formFields.coordination_term_int,
        'disabled',
        !this.setCoordinationTerm
      );
      // разобраться почему подставлялось значение только после перезагрузки страницы
      // this.form.coordination_term_int = this.setCoordinationTerm
      //   ? this.form.coordination_term_int
      //   : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.no-error {
  & ::v-deep .el-form-item__error {
    display: none;
  }
}

.application-stage {
  margin-top: 16px;
  border: 1px solid $grey8;
  border-radius: 8px;

  &__header {
    display: flex;
    padding: 24px;
    border-radius: 4px 4px 0 0;
    border-color: $grey8;
    gap: 16px;
    align-items: flex-end;
  }

  .header {
    &__delete-stage-button {
      margin-top: 40px;
      height: 40px;
    }

    &-form {
      width: 100%;
      &__field {
        &-name {
          max-width: 260px;
        }
        &-coordination-term {
          max-width: 110px;

          & ::v-deep .el-input__inner:focus {
            border-color: $border-focused !important;
          }

          & ::v-deep .el-input.is-disabled {
            & > .el-input__inner {
              border-color: $black-30 !important;
            }
          }
        }
        &-operator {
          max-width: 216px;

          & ::v-deep .el-form-item__label {
            padding: 0;
          }
        }
      }

      & > .no-margin {
        gap: 16px;
        margin-bottom: -16px;
      }
    }
  }

  &__body {
    display: flex;
    padding: 24px;
    border-top: 1px solid $grey8;
  }

  &-coordinators {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .coordinator {
      display: flex;
      gap: 16px;

      &__type,
      &__value {
        max-width: 513px;
      }

      &__type {
        flex-grow: 1;
      }

      &__value {
        flex-grow: 2;

        &.empty-value {
          & ::v-deep .el-input__inner {
            border: 1px solid $red-error !important;
          }
        }
      }

      &__add-button {
        margin-top: 16px;
        width: 100%;
      }

      &__delete-button {
        flex-grow: 1;
        max-width: 236px;
      }
    }
  }
}

.no-margin {
  padding: 0;
  margin-left: 0;
  display: flex;

  .sub-fields {
    .el-form-item__content {
      display: flex;
    }
  }

  .el-form-item {
    margin: 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
